import { ReactNode } from "react";
import {
  ShellContainer,
  MainSection,
  customScrollbar,
} from "@cdkglobal/radial";
import styled from "styled-components";
import { Navigation } from "./pages/Navigation/Navigation";
import { StyledSideSheetOverlay } from "./utils/styled";
import { useUIStateContext } from "./contexts/UIStateContext";

const StyledShellContainer = styled(ShellContainer)`
  height: calc(100vh);
  grid-template-rows: auto auto 1fr auto;
`;

const StyledMainSection = styled(MainSection)`
  background-color: ${({ theme }) =>
    theme.color.secondary.grapeApePurple[200]?.value};
  overflow-y: hidden;
`;

const StyledContentDiv = styled.div`
  ${customScrollbar}
  height: 100%;
  background-color: ${({ theme }) => theme.color.additional.light.value};
`;

interface AppLayoutProps {
  children: ReactNode;
  showNavigation?: boolean;
}

const AppLayout = ({
  children,
  showNavigation = true,
}: Readonly<AppLayoutProps>): JSX.Element => {
  const { isSideSheetOpen } = useUIStateContext();

  return (
    <StyledShellContainer>
      <StyledSideSheetOverlay isCollapsed={!isSideSheetOpen} />

      {showNavigation && <Navigation />}

      <StyledMainSection>
        <StyledContentDiv>{children}</StyledContentDiv>
      </StyledMainSection>
    </StyledShellContainer>
  );
};

export default AppLayout;
